// extracted by mini-css-extract-plugin
module.exports = {"performance-card":"style_performance-card__2fYbn","selected":"style_selected__3mSNy","icon":"style_icon__YFRTt","dropdown":"style_dropdown__1dnZ-"};